import React from 'react';
export const EditableListHeader = (props) => {
    const { children } = props;
    return <>{children}</>;
};
export default EditableListHeader;
